// This file is updated using the cli
// No not modify!
import React from 'react';
const Icon = (props) => {
    return (React.createElement("svg", Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 7 8", width: "7", height: "8" }, props),
        React.createElement("g", { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
            React.createElement("g", { transform: "translate(-632 -175)" },
                React.createElement("path", { d: "M635 183 635 177.2418 633.226 179 632 178.4697 635.4998 175 639 178.4693 637.7753 178.9985 636 177.2414 635.999 182 639 182 639 183z" })))));
};
Icon.displayName = 'ArrowUp7x8';
export default Icon;
//# sourceMappingURL=ArrowUp7x8.js.map